'use client';

import Button from '@ui/Button';
import Typography from '@ui/Typography';
import { joinUrl } from '@utils/stringHelpers';
import useShareModalStore from '@/components/store/shareModalSlice';
import { usePathname } from 'next/navigation';
import React from 'react';
import { HiOutlineShare } from 'react-icons/hi';
import useUserProfile from '@/hooks/useUserProfile';
import { recordShareClick } from '@/actions/public/server.actions';
import Tooltip from '../next-ui/Tooltip';


function ShareButton(props) {
  const {
    variant = 'iconText',
    url,
    title,
    description,
    disabled = false,
    myProfile,
    recordPayload = null,
  } = props;
  const pathName = usePathname();
  const user = useUserProfile();
  const setShowShareModal = useShareModalStore((state) => state.setOpen);

  const handleShare = () => {
    if (!disabled) {
      let shareUrl = url || `${window.location.origin}${pathName}`;
      if (!shareUrl.startsWith(window.location.origin)) {
        shareUrl = joinUrl(window.location.origin, url);
      }

      if (myProfile) {
        shareUrl = joinUrl(
          window.location.origin,
          `/profile/${user.profileUrl}`,
        );
      }

      setShowShareModal(true, {
        url: shareUrl,
        title: title,
        description: description,
      });

      if (recordPayload) {
        // setTimeout(() => {
        recordShareClick(recordPayload);
        // }, 2000);
      }
    }
  };

  return (
    <>
      {variant === 'icon' && (
        <Button
          variant="icon"
          className="!bg-primary !p-1"
          disabled={disabled}
          onClick={handleShare}>
          <HiOutlineShare className="h-4 w-4 text-white" />
        </Button>
      )}
      {variant === 'iconText' && (
        <Tooltip
          content={disabled ? 'The post is not public' : null}
          className="w-max">
          <Button
            as="div"
            variant="plain"
            onClick={handleShare}
            disabled={disabled}
            // title={disabled ? 'The post is not public' : ''}
            className={`${disabled ? 'cursor-not-allowed' : ''}`}>
            <div className="flex items-center justify-center gap-4">
              <HiOutlineShare className="text-text-secondary" />
              <Typography variant="h6">Share</Typography>
            </div>
          </Button>
        </Tooltip>
      )}
      {variant === 'text' && (
        <Button
          variant="outlined"
          color="primary"
          onClick={handleShare}
          disabled={disabled}>
          Share
        </Button>
      )}
    </>
  );
}

export default ShareButton;
